/* eslint-disable jsx-a11y/no-static-element-interactions -- 창 틀·타이틀바의 마우스 핸들러는 앞으로 올리기·최대화 보조다. 키보드는 onFocusCapture 와 창 버튼이 맡는다 */
import type { ReactNode } from 'react';
import * as s from './DesktopWindow.css';

interface WindowTitleBarProps {
  title: ReactNode;
  titleClass: string;
  maximized: boolean;
  onMaximize: () => void;
  onMinimize: () => void;
  onClose: () => void;
}

export function WindowTitleBar({
  title,
  titleClass,
  maximized,
  onMaximize: handleMaximize,
  onMinimize: handleMinimize,
  onClose: handleClose,
}: WindowTitleBarProps) {
  return (
    <div className={`${s.titleBar} desktop-window-titlebar`} onDoubleClick={handleMaximize}>
      <span className={titleClass}>{title}</span>
      <div
        className={s.windowControls}
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className={`${s.controlButton} ${s.controlMinimize}`}
          onClick={(e) => {
            e.stopPropagation();
            handleMinimize();
          }}
          aria-label="최소화"
        >
          &#x2500;
        </button>
        <button
          type="button"
          className={`${s.controlButton} ${s.controlMaximize}`}
          onClick={(e) => {
            e.stopPropagation();
            handleMaximize();
          }}
          aria-label={maximized ? '이전 크기로 복원' : '최대화'}
        >
          {maximized ? '\u29C9' : '\u25A1'}
        </button>
        <button
          type="button"
          className={`${s.controlButton} ${s.controlClose}`}
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          aria-label="닫기"
        >
          &#x2715;
        </button>
      </div>
    </div>
  );
}
